import { LuTrash2 } from "react-icons/lu";
import DeleteConfirmationDialog from "components/DeleteConfirmationDialog/DeleteConfirmationDialog";
import "./draftBulkActions.css";

export function DraftCheckbox({ bulk, id, label }) {
  if (!bulk.enabled || !bulk.canSelect(id)) return null;
  return <input className="draft-selection-checkbox" type="checkbox"
    aria-label={`Select draft ${label}`} checked={bulk.ids.includes(String(id))}
    disabled={bulk.disabled} onChange={() => bulk.toggle(id)}
    onClick={(event) => event.stopPropagation()}
    onKeyDown={(event) => event.stopPropagation()} />;
}

export default function DraftBulkActions({ bulk }) {
  if (!bulk.enabled) return null;
  return <>
    {bulk.count > 0 && (
      <div className="draft-bulk-actions" aria-label="Draft selection">
        <button type="button" className="draft-bulk-delete" disabled={bulk.disabled}
          onClick={bulk.requestDelete}><LuTrash2 aria-hidden="true" />Delete</button>
      </div>
    )}
    <DeleteConfirmationDialog open={bulk.open} title="Delete selected drafts?"
      message={`${bulk.count} selected draft${bulk.count === 1 ? "" : "s"} will ${bulk.permanent ? "be permanently deleted" : "move to Voided"}. This action cannot be undone.`}
      confirmLabel="Delete" confirmTone="primary" loadingLabel="Deleting drafts…" loading={bulk.busy}
      error={bulk.error} handleDelete={bulk.remove} handleCancel={bulk.close}
      closeModalClick={bulk.close} />
  </>;
}
